import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { TransactionMaterial } from "fe-shared-transactions/src/types";

import styles from "../InventoryAdjustmentsDetails.module.scss";

interface Props {
  isAddition?: boolean;
  title: string;
  materials: TransactionMaterial[];
}

const InventoryAdjustmentDetailsActionTransactionContentRow = ({
  title,
  isAddition = false,
  materials,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.actionSubheaderContainer}>
        <h2 className={styles.sectionTitle}>{title}</h2>
        <span>{t("inventoryAdjustment.details.adjustments")}</span>
      </div>
      <div className={styles.actionContentContainer}>
        {materials.map((material: TransactionMaterial) => (
          <div key={material.materialName} className={styles.actionContentRow}>
            <div>{material.materialName}</div>
            <div
              className={classnames({
                [styles.actionContentAddition]: isAddition,
                [styles.actionContentSubtraction]: !isAddition,
              })}
            >
              {`${isAddition ? "+" : "-"}${Math.abs(
                material.units.unitQuantity
              )}`}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default InventoryAdjustmentDetailsActionTransactionContentRow;
